import type { FilterActions, GetMetaActions } from '~/utils'
import CartActions from './cart'
import ProductsActions from './products'

export const Actions = {
	...CartActions,
	...ProductsActions
}

export type ActionCreator = (typeof Actions)[keyof typeof Actions]
type A = ReturnType<ActionCreator>

export type Action<TKey extends Action['type'] = any, TAction extends A = A> = TAction extends { type: TKey }
	? TAction
	: never

export type ErrorAction = FilterActions<Action, 'ERROR'>
export type SuccessAction = FilterActions<Action, 'SUCCESS'>

export type MetaAction = GetMetaActions<Action>
export type ActionTypes<TSearch = null> = TSearch extends string
	? FilterActions<Action, TSearch>['type']
	: Action['type']

export interface AnyAction {
	[extraProps: string]: any
	type: ActionTypes
}
